import { Screen } from '@accounts/navigation';
import { usePresence } from '@accounts/session';
import { Deletion, Outage } from '@accounts/ui';
import { Data } from './security/data';
import { Devices } from './security/devices';
import { Factors } from './security/factors';
import { Password } from './security/password';
import { Ways } from './security/ways';

/**
 * How a person gets into this account, how it is protected, and where they are currently signed in.
 *
 * They belong on one screen because they are the same question asked several ways, and because the
 * action someone reaches for when they think something is wrong — ending other sessions — should be
 * next to the list of ways in, not buried in a settings menu. Each section reads and answers for
 * itself, so one that cannot be read leaves the others usable. When Accounts does not answer them the
 * page says so once (`Outage`, D163), with one Try again for all of them, and each section says it in
 * its own place.
 */
export function Security() {
	const { text } = usePresence();
	return (
		<Screen template="settings" title={text('nav.security')}>
			<Outage>
				<Deletion />
				<Ways />
				<Password />
				<Factors />
				<Devices />
				<Data />
			</Outage>
		</Screen>
	);
}
